import { render, staticRenderFns } from "./CarGroupListView.vue?vue&type=template&id=4e9976b4&scoped=true"
import script from "./CarGroupListView.vue?vue&type=script&lang=js"
export * from "./CarGroupListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9976b4",
  null
  
)

export default component.exports